import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Star } from 'lucide-react';
import { SearchBar } from './SearchBar';
import { HEADER_NAV_ITEMS } from '@shared/constants/navigation';
import { useAuth } from '@core/auth/hooks/useAuth';
import { ROUTES } from '@shared/constants/routes';

export function MobileMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const { isAuthenticated, user, logout } = useAuth();

  const handleClose = () => setIsOpen(false);

  return (
    <div className="md:hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="text-brand-carbon hover:text-brand-mauve transition-colors"
        aria-label={isOpen ? 'Cerrar menú' : 'Abrir menú'}
        aria-expanded={isOpen}
      >
        {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
      </button>

      {isOpen && (
        <div className="absolute left-0 right-0 top-full bg-white border-t border-border shadow-lg z-50">
          <div className="container mx-auto px-4 py-4">
            <SearchBar className="mb-4" onSearch={handleClose} />

            <nav className="space-y-2">
              {HEADER_NAV_ITEMS.map((item) => (
                <Link
                  key={item.href}
                  to={item.href}
                  onClick={handleClose}
                  className={`flex items-center gap-2 py-2 text-sm font-medium transition-colors ${
                    item.highlight
                      ? item.icon === 'Star'
                        ? 'text-amber-600'
                        : 'text-brand-mauve'
                      : 'text-brand-carbon hover:text-brand-mauve'
                  }`}
                >
                  {item.icon === 'Star' && (
                    <Star className="h-4 w-4 fill-amber-600" />
                  )}
                  {item.label}
                </Link>
              ))}
            </nav>

            <div className="mt-4 pt-4 border-t border-border">
              {isAuthenticated ? (
                <div className="space-y-2">
                  <p className="text-sm text-muted-foreground">
                    Hola, {user?.fullName}
                  </p>
                  <Link
                    to={ROUTES.PROFILE}
                    onClick={handleClose}
                    className="block py-2 text-sm text-brand-carbon hover:text-brand-mauve"
                  >
                    Mi Perfil
                  </Link>
                  <Link
                    to={ROUTES.ORDERS}
                    onClick={handleClose}
                    className="block py-2 text-sm text-brand-carbon hover:text-brand-mauve"
                  >
                    Mis Pedidos
                  </Link>
                  <button
                    onClick={() => {
                      handleClose();
                      logout();
                    }}
                    className="block w-full text-left py-2 text-sm text-brand-plum hover:text-brand-mauve"
                  >
                    Cerrar Sesión
                  </button>
                </div>
              ) : (
                <div className="flex flex-col gap-2">
                  <Link
                    to={ROUTES.LOGIN}
                    onClick={handleClose}
                    className="block py-2 text-sm text-brand-carbon hover:text-brand-mauve"
                  >
                    Ingresar
                  </Link>
                  <Link
                    to={ROUTES.REGISTER}
                    onClick={handleClose}
                    className="block rounded-md bg-primary px-4 py-2 text-center text-sm font-medium text-primary-foreground hover:bg-brand-plum transition-colors"
                  >
                    Registrarse
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
